export default "__VITE_ASSET__BbeD7SLQ__"